"use client"

import { Copy, CopyCheck } from "lucide-react"
import { useState } from "react"

import { useToast } from "@/hooks/use-toast"

import { Boilerplate } from "@prisma/client"
import { track } from "@vercel/analytics/react"

export default function CouponCode({
  boilerplate,
}: {
  boilerplate: Boilerplate
}) {
  const { toast } = useToast()
  const [isCopied, setIsCopied] = useState(false)

  return boilerplate?.couponCode ? (
    <div className="flex h-[48px] w-fit items-center gap-3 rounded-md bg-orange-200 px-3 font-medium text-orange-700">
      <p className="flex flex-col justify-center"><span className="font-semibold">{boilerplate?.couponCode}</span> <span className="text-sm">(GET {boilerplate.couponDiscount} OFF)</span></p>
      <button
        aria-label="Copy coupon code"
        name="Copy coupon code"
        onClick={() => {
          navigator.clipboard.writeText(boilerplate?.couponCode ?? "")
          setIsCopied(true)
          track("click_copy_coupon_code", {
            boilerplateId: boilerplate.id,
          })
          toast({
            title: "Coupon code copied",
            description: "You can now paste it in the checkout page",
          })
        }}
        type="button"
        role="button"
      >
        {isCopied ? (
          <CopyCheck className="h-5 w-5" />
        ) : (
          <Copy className="h-5 w-5" />
        )}
      </button>
    </div>
  ) : (
    <></>
  )
}
